import { Component, Injector, Input, OnInit } from '@angular/core';
import * as moment from '@node_modules/moment-timezone';
import { interval, Subscription } from '@node_modules/rxjs';
import { finalize } from '@node_modules/rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { AbpValidationError } from '@shared/components/validation/abp-validation.api';
import { StringUtils } from '@shared/helpers/StringUtils';
import { MessageType } from '@shared/model/message-type-enum.model';
import { CreatePacienteDto, EnumDto, EnumServiceProxy, PacienteServiceProxy } from '@shared/service-proxies/service-proxies';
import { ValidarCpfService } from '@shared/services/validar-cpf.service';

@Component({
  selector: 'responsavel-form-cadastro-paciente',
  templateUrl: './responsavel-form-cadastro-paciente.component.html',
  styleUrls: ['./responsavel-form-cadastro-paciente.component.scss']
})
export class ResponsavelFormCadastroPacienteComponent extends AppComponentBase implements OnInit {

  @Input() model: CreatePacienteDto;
  @Input() ehEstrangeiro: boolean;
  intervalSubscription: Subscription;
  disabledNomeResponsavelLegal: boolean = false;
  requiredPasswordResponsavelLegal: boolean = true;
  subscriptions: Subscription[] = [];
  grausParentesco: EnumDto[] = [];
  dataResponsavel: string;
  showPassword: boolean = false;
  private passwordRegex = /(?=^.{8,}$)(?=.*\d)(?=.*[a-zA-Z])(?!.*\s)[0-9a-zA-Z!.@#$%^&*()]*$/;

  passwordValidationErrors: Partial<AbpValidationError>[] = [
    {
      name: "pattern",
      localizationKey:
        "PasswordsMustBeAtLeast8CharactersContainCharactersNumber",
    },
  ];

  constructor(
    injector: Injector,
    private readonly _pacienteService: PacienteServiceProxy,
    private readonly _cpfService: ValidarCpfService,
    private readonly _enumService: EnumServiceProxy,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getGrausParentesco();
  }

  protected visualizarSenha() {
    this.showPassword = !this.showPassword;
  }

  public isValided(): boolean {

    this.model.responsavelLegaDataNascimento = moment(this.dataResponsavel, "DD/MM/YYYY");
    const hoje = moment();

    return this.showErros([
      { condition: this.ehEstrangeiro && StringUtils.isNullOrEmpty(this.model.responsavelLegalNumeroPassaporte), message: "Informe o passaporte!" },
      { condition: !this.ehEstrangeiro && StringUtils.isNullOrEmpty(this.model.responsavelLegalCpf), message: "Informe o cpf!" },
      { condition: StringUtils.isNullOrEmpty(this.model.responsavelLegalNome), message: "Informe o nome!" },
      { condition: StringUtils.isNullOrEmpty(this.model.responsavelLegalCelular), message: "Informe o celular!" },
      { condition: StringUtils.isNullOrEmpty(this.model.grauParentesco), message: "Informe o grau de parentesco!" },
      { condition: StringUtils.isNullOrEmpty(this.model.responsavelLegaDataNascimento), message: "Informe a data de Nascimento!" },
      { condition: !this.model.responsavelLegaDataNascimento.isValid(), message: "tata de nascimento inválida!" },
      { condition: this.model.responsavelLegaDataNascimento.isAfter(hoje), message: "A data de nascimento não pode ser maior que a data atual!" },
      { condition: this.requiredPasswordResponsavelLegal && StringUtils.isNullOrEmpty(this.model.responsavelLegalSenha), message: "Informe a senha!" },
      { condition: this.requiredPasswordResponsavelLegal && !this.senhaValida(this.model.responsavelLegalSenha), message: "A senha deve ter no mínimo 8 caracteres, conter letras e números e não pode ter espaços!" }
    ]);
  }

  protected cpfResponsavelLegalChange($event) {
    if (this.model.ehEstrangeiro && (!$event || $event < 4)) return;

    if (!this.model.ehEstrangeiro && !$event) {
      this.limparDadosResponsavelLegal();
      this.cpfResponsavelLegalFocus();
      return;
    }

    if (!this.model.ehEstrangeiro && $event.length < 11) {
      this.cpfResponsavelLegalFocus();
      return;
    }

    abp.ui.setBusy();

    this.disabledNomeResponsavelLegal = false;
    this.requiredPasswordResponsavelLegal = true;

    var index = this.model.ehEstrangeiro ? this.model.responsavelLegalNumeroPassaporte : this.model.responsavelLegalCpf;
    this._pacienteService.verificarResponsavelLegal(index)
      .pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      )
      .subscribe((resultado) => {

        if (!resultado.success && !resultado.isDependente) {
          if (this._cpfService.isValidCpf($event)) {
            this.limparDadosResponsavelLegal(false);
            this.exibirMensagemResponsavelLegalCpf(resultado.message, false, MessageType.Success);
          }
          else {
            this.cpfResponsavelLegalFocus();
            this.limparDadosResponsavelLegal(false);
          }
        }
        else if (!resultado.success && resultado.isDependente) {
          this.exibirMensagemResponsavelLegalCpf(resultado.message);
        }
        else {
          this.model.responsavelLegalCpf = resultado.paciente.cpf;
          this.model.responsavelLegalId = resultado.paciente.id;
          this.model.responsavelLegalNome = resultado.paciente.nome;
          this.model.responsavelLegalEmail = resultado.paciente.email;
          this.model.responsavelLegalNomeMae = resultado.paciente.nomeMae;
          this.model.responsavelLegalCelular = resultado.paciente.celular;
          this.model.responsavelLegalNomeSocial = resultado.paciente.nomeSocial;
          this.model.responsavelLegalProfissao = resultado.paciente.profissao;
          this.model.responsavelLegalReligiao = resultado.paciente.religiao;
          this.model.responsavelLegaDataNascimento = resultado.paciente.dataNascimento;
          this.dataResponsavel = resultado.paciente.dataNascimento.format("DD/MM/YYYY");
          this.model.responsavelLegalNumeroPassaporte = resultado.paciente.numeroPassaporte;
          this.disabledNomeResponsavelLegal = true;
          this.requiredPasswordResponsavelLegal = false;
          this.exibirMensagemResponsavelLegalCpf(resultado.message, false, MessageType.Success);
        }

      });
  }

  private exibirMensagemResponsavelLegalCpf(message: string, showWarning: boolean = true, messageType: MessageType = MessageType.Error) {
    this.intervalSubscription = interval(1).subscribe((x) => {
      abp.ui.clearBusy();

      if (messageType === MessageType.Error) {
        this.notify.error(message);
        this.intervalSubscription.unsubscribe();
      }

      if (messageType === MessageType.Success) {
        this.notify.success(message);
        this.intervalSubscription.unsubscribe();
      }
    });
  }

  private cpfResponsavelLegalFocus() {
    this.intervalSubscription = interval(1).subscribe((x) => {
      this.notify.error(this.l("InvalidCpf"));
      this.intervalSubscription.unsubscribe();
    })
  }

  private limparDadosResponsavelLegal(clearCpf: boolean = true) {
    if (clearCpf)
      this.model.responsavelLegalCpf = null;

    this.model.responsavelLegaDataNascimento = null;
    this.model.responsavelLegalCelular = null;
    this.model.responsavelLegalEmail = null;
    this.model.responsavelLegalId = null;
    this.model.responsavelLegalNome = null;
    this.model.responsavelLegalSenha = null;
    this.model.responsavelLegalEmailAlternativo = [];
  }

  private getGrausParentesco() {
    this.subscriptions.push(this._enumService.getByEnumName('GrauParentescoEnum').subscribe(parentescos => {
      this.grausParentesco = parentescos.items;
    }));
  }

  private showErros(validations) {
    for (const validation of validations) {
      if (validation.condition) {
        this.notify.warn(this.l(validation.message));
        return false;
      }
    }

    return true;
  }

  private senhaValida(senha: string): boolean {
    return this.passwordRegex.test(senha);
  }
}
